
module.exports = function(a, b){
  var fn = function(){};
  fn.prototype = b.prototype;
  a.prototype = new fn;
  a.prototype.constructor = a;
};


/*****************
 ** WEBPACK FOOTER
 ** (webpack)-dev-server/~/socket.io-client/~/engine.io-client/~/component-inherit/index.js
 ** module id = 24
 ** module chunks = 0
 **/